const iso = (d) => d.toISOString().slice(0, 10);
const eom = (d) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 0));
const nextMonth = (d) => new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth() + 1, 1));
const plus = (d, n) => new Date(d.getTime() + n * 86400000);

// Mirrors backend routes_finance.term_due (Odoo payment-term line rules, latest line wins).
export function termDue(dateStr, lines, days = 0) {
  const d = new Date(`${dateStr}T00:00:00Z`);
  if (!lines || lines.length === 0) return iso(plus(d, days || 0));
  const out = lines.map((ln) => {
    const n = Number(ln.nb_days) || 0;
    switch (ln.delay_type) {
      case "days_after_end_of_month": return plus(eom(d), n);
      case "days_after_end_of_next_month": return plus(eom(nextMonth(d)), n);
      case "days_end_of_month_on_the": {
        const base = plus(d, n);
        const dn = /^\d+$/.test(String(ln.days_next_month || "0")) ? Number(ln.days_next_month || 0) : 1;
        if (!dn) return eom(base);
        const nx = nextMonth(base);
        return new Date(Date.UTC(nx.getUTCFullYear(), nx.getUTCMonth(), Math.min(dn, eom(nx).getUTCDate())));
      }
      default: return plus(d, n);
    }
  });
  return iso(new Date(Math.max(...out.map((x) => x.getTime()))));
}
